import { publishEvent } from './publish-event';

export function publishBasicMembershipSelectionEvent() {
  const event = {
    event: 'basic_membership_selection',
  };

  publishEvent(event);
}
